import { DLECCEncryptionConfig } from '@afe/encryption/dlecc';

export const dldhEncryptionConfig: DLECCEncryptionConfig = {
  url: `/reference-url/cryptographic_security/v1/keys`,
  systemCode: 'bot'
};
